<template>
  <div id="app">
    
     <div>
     </div>
    <div id="content"><component :is="layout"><router-view /></component></div> 
  </div>
</template>
<script>

import auth from "./auth";
const default_layout = 'deflayout';
export default {
  name: "mainApp",
  computed:{
    layout(){
      return (this.$route.meta.layout || default_layout);
    }
  },
  
  methods: {
    out() {
      auth.logout();
    }
    
  },
 
};

</script>
<style>
/* button */
#app{
  /* font-family: 'Arial'; */
  font-family: Georgia;
}

.defButton {
  outline: 0;
  background: #5597b4;
  border: 0;
  padding: 10px 1rem;
  margin: 5px 10px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  border-radius: 15px;
  transition: all 0.5s;
  width: fit-content;
}


</style>

